import Image from 'next/image';

import { PlatformID } from '@common/clients/api';
import styles from '@web/templates/ErrorPages/molecules/ErrorBackground/ErrorBackground.module.scss';

interface Props {
    platformID?: PlatformID;
}

const ERROR_IMAGE_BY_PLATFORM: Partial<Record<PlatformID, string>> = {
    [PlatformID.BR]: '404-br.jpg',
    [PlatformID.VN]: '404-vn.jpg',
    [PlatformID.VP]: '404-vp.jpg',
};

export const ErrorBackground = ({ platformID }: Props) => {
    const filename = platformID ? ERROR_IMAGE_BY_PLATFORM[platformID] : undefined;

    if (!filename) {
        return null;
    }

    return (
        <div className={styles['ErrorBackground']}>
            <Image alt="404-image" fill src={`/images/page/${filename}`} />
        </div>
    );
};
